import { render, staticRenderFns } from "./StudioCommunityGroupTabs.vue?vue&type=template&id=36e3fb4b&scoped=true&"
import script from "./StudioCommunityGroupTabs.vue?vue&type=script&lang=ts&"
export * from "./StudioCommunityGroupTabs.vue?vue&type=script&lang=ts&"
import style0 from "./StudioCommunityGroupTabs.vue?vue&type=style&index=0&id=36e3fb4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e3fb4b",
  null
  
)

export default component.exports